###
  Init bootstrap affix on document.ready
  You can use data-spy="affix" instead
  http://getbootstrap.com/javascript/#affix
###

class INTENT.widgets.Affix

  @ATTR_NAME: "data-widget-affix"

  constructor: (@el) ->
    @s = @.constructor
    options = {}

    offset_top = @el.attr "#{@s.ATTR_NAME}-offset-top"
    offset_bottom = @el.attr "#{@s.ATTR_NAME}-offset-bottom" || offset_top
    if offset_top?
      options.offset =
        top: offset_top
        bottom: offset_bottom
    else
      options.offset =
        top: @el.offset().top
        bottom: 0

    @el.affix options